import { jsx as _jsx } from "react/jsx-runtime";
import { Slot } from "@radix-ui/react-slot";
import cn from "../../../utils/cn";
const MenuItem = ({ asChild, children, className, onClick, disabled = false }) => {
    const Comp = asChild ? Slot : "button";
    return (_jsx(Comp, { onClick: onClick, disabled: disabled, className: cn([
            "group flex h-8 w-full",
            "flex-row items-center",
            "rounded-md py-0.5 pr-3 pl-2",
            "transition-all duration-300 ease-in-out",
            "hover:bg-gray-lightest",
            "active:scale-95",
            "disabled:opacity-50 disabled:hover:bg-transparent",
            className,
        ]), children: children }));
};
export default MenuItem;
